import { Button } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

const EMAIL_DOMAINS = [
  '@gmail.com',
  '@yahoo.fr',
  '@orange.fr',
  '@hotmail.com',
  '@outlook.fr',
  '@laposte.net',
] as const;

type EmailDomainSuggestionsProps = {
  value: string;
  onSelect: (domain: string) => void;
};

/**
 * Accessory bar shown under the email field on public kiosks (Mockup A):
 * one tap on a provider completes the address, no long typing, no typo.
 * Hidden as soon as the address already contains "@" (complete).
 */
const EmailDomainSuggestions = ({ value, onSelect }: EmailDomainSuggestionsProps) => {
  const { t } = useTranslation();

  if (value.includes('@')) return null;

  const canSuggest = value.trim().length > 0;

  return (
    <div className="flex flex-col gap-3" role="group" aria-label={t('EmailDomainSuggestions.hint')}>
      <p className="text-sm font-medium text-muted-foreground">
        {t('EmailDomainSuggestions.hint')}
      </p>
      <div className="flex flex-wrap gap-2">
        {EMAIL_DOMAINS.map(domain => (
          <Button
            key={domain}
            type="button"
            variant="outline"
            size="lg"
            disabled={!canSuggest}
            onClick={() => onSelect(domain)}
            className="px-5"
          >
            {domain}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default EmailDomainSuggestions;
